import React from "react";
import {
  Flex,
  Text,
  Modal,
  Button,
  ModalBody,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const ConfirmationModal = ({
  isOpen,
  onClose,
  location,
  onCloseSummaryModal,
}) => {
  const navigate = useNavigate();

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent
        minW={"800px"}
        borderRadius={"16px"}
        p={6}
        alignSelf={"center"}
      >
        <ModalBody
          gap={4}
          display={"flex"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          <Text
            fontSize={"24px"}
            fontFamily={"PlusJakartaSansSemiBold"}
            color={"#000000"}
            textAlign={"center"}
            textTransform={"uppercase"}
          >
            YOUR HAVE CHOSEN {location?.name} AS YOUR DROP OFF POINT!
          </Text>
          <Text
            fontSize={"16px"}
            fontFamily={"PlusJakartaSansRegular"}
            color={"#000000"}
            textAlign={"center"}
            textTransform={"lowercase"}
          >
            Please drop off the bags in the selected location at your own
            convenience
          </Text>
          <Flex justifyContent={"center"} gap={3} pt={6}>
            <Button
              bg="#000000"
              borderRadius="12px"
              color="#FFFFFF"
              size="12px"
              fontSize={"12px"}
              fontFamily="PlusJakartaSansMedium"
              w={"358px"}
              h={"40px"}
              textTransform={"uppercase"}
              onClick={() => {
                onCloseSummaryModal();
                onClose();
                navigate("/send-a-bag");
              }}
            >
              CLOSE
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
